"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InquireAssociatedAccessIDResponseMapper = void 0;
var InquireAssociatedAccessIDResponseMapper = /** @class */ (function () {
    function InquireAssociatedAccessIDResponseMapper(data) {
        this.localData = data;
    }
    InquireAssociatedAccessIDResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return InquireAssociatedAccessIDResponseMapper;
}());
exports.InquireAssociatedAccessIDResponseMapper = InquireAssociatedAccessIDResponseMapper;
//# sourceMappingURL=InquireAssociatedAccessIDResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/InquireAssociatedAccessIDResponseMapper.js
// module id = 1970
// module chunks = 8